import {
  BaseApiClient,
  JSONApiResponse,
  VoidApiResponse,
} from "../../core/api";
import {
  MessageBirdConversationChannel,
  MessageBirdConversationChannelFromJSON,
} from "../model/messagebird-conversation-channel";
import {
  MessageBirdSV2ubscriptionFromJSON,
  MessageBirdV2Subscription,
} from "../model/messagebird-v2-subscription";

class MessagebirdApiV2Client extends BaseApiClient {
  webhookUrl = "/api/integration-service/webhook/messagebird-v2";

  async getSubscriptions(): Promise<MessageBirdV2Subscription[]> {
    const response = await this.fetchApi(`${this.webhookUrl}/subscriptions`);
    return new JSONApiResponse(response, (json) =>
      json.map(MessageBirdSV2ubscriptionFromJSON)
    ).value();
  }

  async getChannels(): Promise<MessageBirdConversationChannel[]> {
    const response = await this.fetchApi(`${this.webhookUrl}/channels`);

    return new JSONApiResponse(response, (jsonValue) =>
      (jsonValue as any[]).map(MessageBirdConversationChannelFromJSON)
    ).value();
  }

  async getEvents(): Promise<string[]> {
    const response = await this.fetchApi(`${this.webhookUrl}/events`);

    return new JSONApiResponse(
      response,
      (jsonValue) => jsonValue as string[]
    ).value();
  }

  async createSubscription(body: { channelId: string; events: string[] }) {
    const response = await this.fetchApi(`${this.webhookUrl}/subscriptions`, {
      method: "POST",
      body: JSON.stringify(body),
    });

    return new VoidApiResponse(response).value();
  }

  async deleteSubscription(id: string): Promise<void> {
    const response = await this.fetchApi(
      `${this.webhookUrl}/subscriptions/${id}`,
      {
        method: "DELETE",
      }
    );
    return new VoidApiResponse(response).value();
  }
}

export const MessageBirdV2Api = new MessagebirdApiV2Client();
